import type { VoidFunctionComponent } from 'react';

import List from '../../../generic/List';
import DependencyTableContents from '../DependenciesTable/DependencyTableContents';
import type { DependencyV2Modals } from '../hooks/useDependencyModals';

import styles from './VendoredDependenciesLayout.module.less';

type Props = {
  modals: DependencyV2Modals;
  setSelectedDependencyRevisionLocator: (locator: string) => void;
  removeDependency: (locator: string, isManual: boolean) => void;
  setDependencyLocatorToEdit: (locator: string | null) => void;
  setInProgressBuildId: (buildId: number | null) => void;
  handleOverwriteManualDependency: (overwriteDependencyLocator: string) => void;
};

/**
 * Table contents for vendored dependencies view.
 * Renders dependency rows without the List.Header (the header is supplied by the
 * resizable file-tree layout's content header).
 */
const VendoredTableContents: VoidFunctionComponent<Props> = ({
  modals,
  setSelectedDependencyRevisionLocator,
  removeDependency,
  setDependencyLocatorToEdit,
  setInProgressBuildId,
  handleOverwriteManualDependency,
}) => {
  return (
    <List isBorderless className={styles.borderlessList}>
      <List.Body>
        <DependencyTableContents
          modals={modals}
          setSelectedDependencyRevisionLocator={setSelectedDependencyRevisionLocator}
          removeDependency={removeDependency}
          setDependencyLocatorToEdit={setDependencyLocatorToEdit}
          setInProgressBuildId={setInProgressBuildId}
          handleOverwriteManualDependency={handleOverwriteManualDependency}
        />
      </List.Body>
    </List>
  );
};

export default VendoredTableContents;
